import { createTheme } from '@mui/material/styles';
import { R } from './R';

import "./MuiTheme.css";

export function MuiTheme(
) {
  const header_line_height = 1.25;
  const text_line_height = 1.75;

  //#region 全局樣式 Theme
  // 官方預設值: https://mui.com/zh/material-ui/customization/default-theme/
  let theme = createTheme({
    palette: {
      primary: {
        main: R.color.primary
      },
      secondary: {
        main: R.color.accent
      },


    },

    typography: {
      fontFamily: ['Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'CustomFont'].join(","),
      h1: { fontSize: "2.571rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 36 = Display4
      h2: { fontSize: "2.285rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 32 = Display3
      h3: { fontSize: "2rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 28 = Display2
      h4: { fontSize: "1.85rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 26 = Display1

      h5: { fontSize: "1.7142rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 24 = headline
      h6: { fontSize: "1.4285rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 20b = title
      subtitle1: { fontSize: "1.14285rem", fontWeight: 400, lineHeight: header_line_height, latterSpacing: "0em" },// 16
      subtitle2: { fontSize: "1.14285rem", fontWeight: 700, lineHeight: header_line_height, latterSpacing: "0em" },// 16b
      body1: { fontSize: "1rem", fontWeight: 400, lineHeight: text_line_height, latterSpacing: "0em" },// 14
      body2: { fontSize: "1rem", fontWeight: 700, lineHeight: text_line_height, latterSpacing: "0em" },// 14b
      button: { fontSize: "1rem", fontWeight: 700, lineHeight: text_line_height, latterSpacing: "0em", textTransform: "none" },// 14b
      caption: { fontSize: "0.8571rem", fontWeight: 400, lineHeight: text_line_height, latterSpacing: "0em" },// 12
      overline: { fontSize: "0.7142rem", fontWeight: 400, lineHeight: text_line_height, textTransform: "none", latterSpacing: "0em" },// 10
    },
  });
  //#endregion
  return theme;
}

//#region 客製化按鈕顏色 - 調色板
// https://mui.com/zh/customization/palette/#adding-new-colors
//#endregion